import React from 'react';

import {EMPTY_SEARCH_RESULT_PROPS} from 'notebook/mediocre/search/SearchResultProps';
import TableTitleBar from 'notebook/tables/core-ui/TableTitleBar';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {TableCollapserContext} from 'ui-library/tables/TableCollapserContext';

import {TableIndicatorStatus} from '../TableConstants';

interface LoadingTablePlaceholderProps {
  icon?: BenchlingIconName | null;
  tableName: string | JSX.Element;
}

/**
 * Component that represents a collapsed table with a progress bar indicating that the
 * data in the table is still loading.
 */
export default function LoadingTablePlaceholder(props: LoadingTablePlaceholderProps): JSX.Element {
  return (
    <div className="u-small-padding mediocre react-tab-container--mediocre-tableWrapper">
      {/* eslint-disable-next-line react/jsx-no-constructed-context-values -- Disabling for now, but worth fixing */}
      <TableCollapserContext.Provider value={{isTableInitiallyCollapsed: true}}>
        <TableTitleBar
          icon={props.icon}
          isTableExpanded={false}
          isTableMaximized={false}
          isTableSplitScreen={false}
          isFocused={false}
          isLoading={true}
          disableMaximize={true}
          useRoundedBottomBorder={true}
          tableIndentationPx={0}
          tableName={props.tableName}
          shouldRenderCollapserChevron={false}
          usePointerCursor={false}
          status={TableIndicatorStatus.NO_STATUS}
          {...EMPTY_SEARCH_RESULT_PROPS}
        />
      </TableCollapserContext.Provider>
    </div>
  );
}
